import { type FC, lazy, Suspense } from "react"

import type { LandingPageLeadFormBlock } from "@forento/core/models/landing"
import { cn } from "@forento/ui/utilities/tailwind"

const RichTextPreview = lazy(() => import("@forento/ui/components/RichTextPreview"))

type Props = {
	block: LandingPageLeadFormBlock
}

const fieldClassName =
	"mt-1 w-full rounded-lg border border-landing-border bg-landing-surface px-3 py-2.5 text-landing-foreground text-sm shadow-sm"

const LeadFormBlockPreview: FC<Props> = ({ block }) => {
	const isInquiry = block.content.kind === "inquiry"

	return (
		<section className="px-6 pt-16 pb-0 sm:pt-20 lg:px-8">
			<div className="mx-auto max-w-lg">
				<h2 className="text-landing-foreground text-center text-3xl font-bold tracking-tight sm:text-4xl">
					{block.content.title || "Form title"}
				</h2>
				{block.content.description && (
					<Suspense>
						<RichTextPreview
							value={block.content.description}
							className="text-landing-foreground-muted mt-4 text-center text-base leading-7 [&>p]:mb-3 [&>p:last-child]:mb-0"
						/>
					</Suspense>
				)}
				<div className="mt-8 space-y-4">
					{isInquiry && (
						<div>
							<span className="text-landing-foreground-muted block text-sm font-medium">
								Name <span className="text-landing-foreground-subtle font-normal">(optional)</span>
							</span>
							<div className={fieldClassName}>&nbsp;</div>
						</div>
					)}
					<div>
						<span className="text-landing-foreground-muted block text-sm font-medium">Email</span>
						<div className={cn(fieldClassName, "text-landing-foreground-subtle")}>you@example.com</div>
					</div>
					{isInquiry && (
						<div>
							<span className="text-landing-foreground-muted block text-sm font-medium">Message</span>
							<div className={cn(fieldClassName, "min-h-32")} />
						</div>
					)}
					<div className="landing-button w-full px-4 py-3 text-center text-sm font-semibold">
						{block.content.submitLabel || "Submit"}
					</div>
				</div>
			</div>
		</section>
	)
}

export default LeadFormBlockPreview
